import { Button, Popup } from "semantic-ui-react";

export default function ResumeLink({ dashboardCard, post, mini, text, icon }) {
  if (!dashboardCard) return null;

  const { generatedResumeUrl } = post;

  if (generatedResumeUrl) {
    return (
      <Popup
        content="View Resume"
        trigger={
          <a href={generatedResumeUrl} rel="noopener noreferrer" target="_blank">
            {!icon ? (
              <Button
                circular
                icon="file"
                color="blue"
                size={mini ? "mini":  "small"}
                onClick={(e) => e.stopPropagation()}
              >
                {text}
              </Button>
            ) : (
              icon
            )}
          </a>
        }
      />
    );
  } 

  return null;
}
